import { FC } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { Splide, SplideSlide } from "@splidejs/react-splide";

import SimpleImage from "../../Media/SimpleImage";

interface GptwBadges {
  id: number;
  name: string;
  src: string;
}
interface Props {
  items: GptwBadges[];
  interval?: number;
}

const GreatPlaceToWork: FC<Props> = ({ items, interval }) => {
  return (
    <section className="great-place-to-work-container">
      <Container>
        <Row className="carousel-content px-0">
          <>
            <Col xxl={7} xl={7} lg={7} md={12} sm={12} xs={12}>
              <div className="gptw-banner-wrapper">
                <h4>
                  Great Product | Great People | Great Place To Work{" "}
                  <span className="gptw-hyphens-auto"></span>
                </h4>
              </div>
            </Col>

            <Col
              xxl={5}
              xl={5}
              lg={5}
              md={12}
              sm={12}
              xs={12}
              className="gptw-slider-main"
            >
              <div className="gptw-slider-section">
                <div className="gptw-text-slider">
                  <Splide
                    options={{
                      type: "loop",
                      perPage: 1,
                      autoplay: true,
                      interval: interval ?? 5000,
                      speed: 1000,
                      easing: "ease-out",
                      pagination: false,
                      arrows: false,
                      width: "100%",
                      perMove: 1,
                      pauseOnHover: false,
                      resetProgress: false,
                      direction: "ttb",
                      heightRatio: 0.25,
                      rewind: false,
                      autoWidth: true,
                    }}
                    aria-labelledby={"GreatPlaceToWork-Text-sections"}
                  >
                    {items.map((item) => {
                      return (
                        <SplideSlide key={item.id}>
                          <h4>{item.name}</h4>
                        </SplideSlide>
                      );
                    })}
                  </Splide>
                </div>
                <div className="gptw-badges-slider">
                  <Splide
                    options={{
                      type: "loop",
                      perPage: 1,
                      autoplay: true,
                      interval: interval ?? 5000,
                      speed: 1000,
                      easing: "ease-out",
                      pagination: false,
                      arrows: false,
                      perMove: 1,
                      pauseOnHover: false,
                      resetProgress: false,
                      rewind: false,
                    }}
                    aria-labelledby={"GreatPlaceToWork-Badge-sections"}
                  >
                    {items.map((item) => {
                      return (
                        <SplideSlide key={item.id}>
                          <SimpleImage src={item.src} />
                        </SplideSlide>
                      );
                    })}
                  </Splide>
                </div>
              </div>
            </Col>
          </>
        </Row>
      </Container>
    </section>
  );
};
export default GreatPlaceToWork;
